import React from 'react';
import { TableContainer, Box, Paper, Table, TableCell, TableHead, TableRow, TableBody, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import useStyles from '../../../themes/makeStyles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 10,
    },
}))(TableCell);

export default function InventoryGrnStatusDetailTable(props) {
    const warehouseData =
        JSON.parse(sessionStorage.getItem("warehouseData")) || {};
    const classes = useStyles();

    return (
        <TableContainer component={Paper} className={classes.container}>
            <Table className={classes.table} aria-label="simple table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell>
                            <b>SAP GRN Status Detail Table </b>
                        </StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>
                            <b>SAP GRN Status</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Category/Commodity Type</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>No. of items</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Value (Cr.)</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>{ warehouseData.warehouse_name.includes('Pravesh') ? "Qty (NOs)" : "Qty (MT)" }</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Space Occupied (Sq Ft.)</b>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {props.inventoryGrnDetailData.map((each, index) => {

                        return (
                            <TableRow key={index}>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b> {each.sap_type ? each.sap_type : '-'} </b>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b> {each.material_category ? each.material_category : '-'} </b>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b> {each.no_of_items ? each.no_of_items : 0} </b>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b> {each.value_in_cr ? each.value_in_cr : 0} </b>
                                    </div>
                                </TableCell>
                                { warehouseData.warehouse_name.includes('Pravesh') ? <TableCell component="th" scope="row">
                                    <div>
                                        <b> {each.unloading_quantity ? each.unloading_quantity : 0} </b>
                                    </div>
                                </TableCell> :
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b> {each.gross_weight ? each.gross_weight : 0} </b>
                                    </div>
                                </TableCell> }
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b> {each.bin_space_allocated ? each.bin_space_allocated : 0} </b>
                                    </div>
                                </TableCell>
                            </TableRow>

                        )
                    }
                    )}

                </TableBody>
            </Table>
        </TableContainer>
    );
} 